import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export async function sendTeacherInvitations(emails, message, institutionId) {
  return axios
    .post(`${BASE_URL}/api/teacher-invitations`, { emails, message, institutionId })
    .then((response) => response.data);
}

export async function deleteTeacherInvitation(studentId, institutionId) {
  return axios.delete(`${BASE_URL}/api/teacher-invitations/students/${studentId}`, {
    params: { institutionId },
  });
}

export async function getStudentInvitations() {
  return axios
    .get(`${BASE_URL}/api/teacher-invitations/student`)
    .then((response) => response.data);
}

export async function respondStudentInvitation(invitationId, status) {
  return axios.put(`${BASE_URL}/api/teacher-invitations/${invitationId}/response`, {
    status,
  });
}
